import React from 'react';
import { Link } from 'react-router-dom';
import { sliderSettingTwoRowFourColumn } from "../../../shared/sliderSetting.js"
import Slider from 'react-slick';
import styles from "../instituteList/instituteList.module.css"
import { useTranslation } from "react-i18next";
import { NEW_URL } from '../../../constants/applicationConstants';
import toprealEttextline from "../../../assets/sharedImages/toprealEttextline.png";

export const InstituteList = (props) => {
    const { t } = useTranslation();

    const {
        instituteData,
        bestInstituteText,
        topRatedText,
        checkOutText,
        finalcialText,
        onInstituteClick,
        isCategory,
        categoryImg,
        topText,
        category,
        instituteID
    } = props;

    const hitShowALL = () => {
        instituteID && localStorage.setItem("selectCategory", instituteID)
    }

    return (
        isCategory ? (
            <section className={`categorysectionthree ${category}-bgimg`}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-7 col-12 p-0">
                            <div className={styles.categorylogosection}>
                                {instituteData?.length > 0 && (
                                    <Slider {...sliderSettingTwoRowFourColumn}>
                                        {instituteData.map((institute, index) => (
                                            <div key={institute?.id || institute?.name || index} className="psi">
                                                <div
                                                    className="colinstititeinner"
                                                    onClick={() => onInstituteClick(institute)}
                                                >
                                                    <div className="colinstititeinnerimage text-center">
                                                        <Link to={`/institute/${institute?.formattedLegalName}`} target="_blank">
                                                            <img
                                                                src={!institute?.imageUrl ? `https://ui-avatars.com/api/?name=${institute?.name}&rounded=false` : `${NEW_URL}/${institute?.imageUrl}`}
                                                                alt={institute?.name || "Institute Image"}
                                                            />
                                                        </Link>
                                                    </div>
                                                    <div className="colinstititeinnername text-center institute-text">
                                                        {institute?.name}
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </Slider>
                                )}
                            </div>
                            <div className={`${styles.showallourbesttwo} mt-4 text-center`} onClick={() => hitShowALL()}>
                                <Link to={'/globalMainSearchInstitutions#searchinstitute'} className={styles.showallourbesttoo}>
                                    {t("COMMON.SHOWALL")}
                                </Link>
                            </div>
                        </div>
                        <div className="col-lg-5 col-12 p-0">
                            <div className="toprealErighttext">
                                <h2>
                                    {topText}
                                    <span>
                                        <img className="toprealEtext" src={categoryImg} alt={categoryImg} />
                                        {topRatedText}
                                    </span>
                                </h2>
                                <img className="toprealEborder" src={toprealEttextline} alt="" />
                                <p>
                                    <span className="topsubtext">{checkOutText}</span>
                                </p>
                                <span className="topsubtextfive">{finalcialText}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        ) : (
            <section className="Ourintitutions">
                <div className="container">
                    <div className="row flexflow">
                        <div className="col-lg-7 col-md-7 col-sm-7 paddleft3">
                            <div className="ourbestimgslider">
                                <Slider {...sliderSettingTwoRowFourColumn}>
                                    {instituteData?.map((offer, index) => (
                                        <div key={offer?.id || offer?.name || index} className={styles.ourbestimg}>
                                            <Link to={`institute/${offer?.formattedLegalName}`} target="_blank">
                                                <div className={styles.ourbestimgbox}>
                                                    <img
                                                        src={!offer?.imageUrl ? `https://ui-avatars.com/api/?name=${offer?.name}&rounded=true` : `${NEW_URL}/${offer?.imageUrl}`}
                                                        alt={offer?.name || 'Institute Image'}
                                                    />
                                                </div>
                                            </Link>
                                        </div>
                                    ))}
                                </Slider>
                            </div>
                            <div className={`${styles.showallourbesttwo} mt-2 text-center`} onClick={() => hitShowALL()}>
                                <Link to={'/globalMainSearchInstitutions#searchinstitute'} className={styles.showallourbesttoo}>
                                    {t("COMMON.SHOWALL")}
                                </Link>
                            </div>
                        </div>
                        <div className={`${styles["our-best-alignment"]} col-md-5 col-sm-5 col-lg-5`}>
                            <div className={styles.ourbestrighttext}>
                                <h2>{bestInstituteText}</h2>
                                <p className="d-block d-lg-none d-sm-none d-md-none">
                                    {topRatedText} {checkOutText} {finalcialText}
                                </p>
                                <p className="d-none d-sm-block">{topRatedText}</p>
                                <p className="d-none d-sm-block">{checkOutText}</p>
                                <p className="d-none d-sm-block">{finalcialText}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    )
}

export default InstituteList;